module.exports = __webpack_public_path__ + "static/media/bg-header-right4669d9385cd604cb0b18dfda40514077.webp";